import "dayjs/locale/pt-br";
import "dayjs/locale/es";
import { useTranslation } from "react-i18next";

export function useDateLocale() {
  const { i18n } = useTranslation();
  const isEn = i18n.language === "en";
  const isEs = i18n.language === "es";
  return {
    dateFormat: isEn ? "MM/DD/YYYY" : "DD/MM/YYYY",
    adapterLocale: isEn ? "en" : isEs ? "es" : "pt-br",
  };
}
